<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs
      v-model="model"
      :background-color="
        $vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'
      "
    >
      <v-tab :href="`#tab-1`" class="px-0 ml-0">B Book</v-tab>
      <v-tab :href="`#tab-2`"> A Book </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <bbook-tab></bbook-tab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card flat>
            <abook-tab></abook-tab>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>
import AbookTab from "./AbookTab.vue";
import BbookTab from "./BbookTab.vue";

export default {
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    BbookTab,
    AbookTab,
  },
};
</script>
